module.exports = __webpack_public_path__ + "static/media/Percival Graves 3.1b8eae4d.jpg";